import {
  BlockControls,
  InspectorControls,
  useBlockProps,
} from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";
import { useMemo, useEffect } from "@wordpress/element";
import AllBlockControls from "./BlockControls";
import AllInspectorSettings from "./InspectorControls";
import { getExtraDOMAttributes, getWrapperDOMAttributes } from "../utils";

export default function Edit(props) {
  const { attributes, setAttributes, clientId } = props;

  const { icon, style, position = "standard" } = attributes;

  // Apply default styles when block is first inserted
  useEffect(() => {
    if (!style || Object.keys(style).length === 0) {
      setAttributes({
        style: {
          color: {
            text: "#fff",
            background: "#000",
          },
          spacing: {
            padding: "10px",
          },
          border: {
            radius: "100px",
          },
        },
      });
    }
  }, []);

  const iconSize = useMemo(() => {
    return icon.size.includes("px") ? icon.size : icon.size + "px";
  }, [icon.size]);

  const blockProps = useBlockProps({
    style: {
      "--brandy-jump-to-section-icon-size": iconSize,
      position: position === "standard" ? "relative" : "fixed",
      top: position === "top-right" ? "50px" : undefined,
      right:
        position === "top-right" || position === "bottom-right"
          ? "30px"
          : undefined,
      bottom: position === "bottom-right" ? "50px" : undefined,
    },
    ...getExtraDOMAttributes(attributes),
  });

  const iconHtml = useMemo(() => {
    if (!icon.name || !icon.type) {
      return "";
    }

    try {
      let html = (
        <div
          className="brandy-jump-to-section-icon-content"
          style={{ color: "inherit", height: iconSize, width: iconSize }}
        >
          <i
            className={`ph${
              icon.type !== "regular" ? "-" + icon.type : ""
            } ph-${icon.name}`}
          ></i>
        </div>
      );

      // Don't store React element as attribute - just return for rendering
      return html;
    } catch (error) {
      console.error("Error generating icon HTML:", error);
      return "";
    }
  }, [icon.name, icon.type, iconSize]);

  return (
    <>
      <InspectorControls>
        <AllInspectorSettings
          setAttributes={setAttributes}
          attributes={attributes}
          clientId={clientId}
        />
      </InspectorControls>
      <BlockControls>
        <AllBlockControls
          clientId={clientId}
          attributes={attributes}
          setAttributes={setAttributes}
        />
      </BlockControls>
      <div {...blockProps}>{iconHtml}</div>
    </>
  );
}
